// eslint-disable-next-line import/no-cycle
import {
    http_get, http_put, http_delete, http_post,
} from './helpers';
import { version } from './config';
import { UserSummary, User, BrandCard } from './types';

// GET /api/v{version}/m/User/Summary
export const getUserSummary = http_get<
    void,
    UserSummary
>(`/api/v${version}/m/User/Summary`);

// GET /api/v{version}/f/User
// 获取用户账号信息
export const getUser = http_get<
    void,
    User
>(`/api/v${version}/f/User`);

// 修改用户信息
export const editUserInfo = http_put<
    {
        nickName?: string;
        avatar?: string;
        phoneNumber?: string;
        profession?: string;
        organization?: string;
        country?: string;
        province?: string;
        city?: string;
    },
    void
>(`/api/v${version}/f/User`);

// PUT /api/v{version}/f/User/Password
// 修改密码
export const putUserPassword = http_put<
    {
        current: string; // 旧密码
        modified: string; // 新密码
    },
    void
>(`/api/v${version}/f/User/Password`);
/**
 * 获取用户关注品牌列表
 */
export const getUserBrands = http_get<
    {
        search: string;
    },
    BrandCard[]
>(`/api/v${version}/m/User/Brands/Concerned`);

/**
 * 关注品牌
 */
export const putUserBrand = http_put<
    {
        brandId: number;
    }[],
    void
>(`/api/v${version}/m/User/Brands`);

/**
 * 取消品牌关注
 */
export const deleteUserBrand = http_delete<
    {
        brandId: number;
    }[],
    void
>(`/api/v${version}/m/User/Brands`);

/**
 * 是否已经登录
 */
export const isLogined = http_get<
    void,
    void
>(`/api/v${version}/m/User/IsLogined`);

/**
 * 获取未读消息数
 */
export const getUnreadCount = http_get<
    void,
    number
>(`/api/v${version}/f/SiteMessages/UnreadCount`);

// 新增页面访问记录
export const postPageVisits = http_post<
    {
        page: string;
        pageName: string;
        clientType: number;
    },
    void
>(`/api/v${version}/f/PageVisits`);

// 获取地区
export const getRegions = http_get<
    {
        parentCode: any;
    },
    any
>(`/api/v${version}/f/Regions`);
/**
 * 找回密码下一步
 */
export const putFindPassword = http_put<
    {
        phoneNumber: string;
        captcha: string;
    },
    void
>(`/api/v${version}/f/Account/FindPassword/NextStep`);
/**
 * 找回密码重置密码
 */
export const putResetPassword = http_put<
    {
        phoneNumber: string;
        captcha: string;
        newPassword: string;
    },
    void
>(`/api/v${version}/f/Account/ResetPassword`);

/**
 * 绑定手机号
 */
    export const bindPhone = http_post <
    {
    phoneNumber: string;
    captcha: string;
    },
    void
    >(`/api/v${version}/f/User/BindPhone`);
